if (!process.env.VUE_APP_IS_WEB) {
  var UserDB = require("../database/models/User");

  var argon2 = require("argon2");
}
import dates from "@/database/dates";
import strings from "@/database/strings";

import UserORM from "@/store/orm-axios/models/User";

export default {
  // NOTE: needed to check if there is a user in local DB
  CHECK_USER_IS_IN_DB() {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new UserDB()
          .fetchAll()
          .then(res => {
            // console.log("res", res);
            var userIsInDB = false;
            if (res.serialize()[0]) userIsInDB = true;
            resolve(userIsInDB);
          })
          .catch(err => {
            console.log("err", err);
            reject(err);
          });
      });
    }
  },
  GET_USER_FROM_DB() {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new UserDB()
          .fetchAll()
          .then(res => {
            // console.log("res", res);
            resolve(res.serialize()[0]);
          })
          .catch(err => {
            console.log("err", err);
            reject(err);
          });
      });
    }
  },
  async ADD_USER_DB(user, username, password) {
    if (!process.env.VUE_APP_IS_WEB) {
      try {
        var hashedPassword = await argon2.hash(password);
      } catch (err) {
        Promise.reject(err);
      }

      var userAdded = JSON.parse(JSON.stringify(user));
      userAdded.username = username;
      userAdded.password = hashedPassword;
      // REVIEW: not necessary anymore?
      // userAdded.roles = JSON.stringify(userAdded.roles);

      return new Promise((resolve, reject) => {
        new UserDB(userAdded)
          .save(null, { ignoreEntityTimestampable: false })
          .then(res => {
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  // FIXME: ..
  CHECK_USER_BY_EMAIL_DB(email) {
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new UserDB({ email: email, deleted: null })
          .fetch()
          .then(res => {
            // console.log(res.serialize());
            resolve("User is the one from local database.");
          })
          .catch(err => {
            reject("User is not the one from local database.");
          });
      });
    }
  },
  async SET_USER_PASSWORD_DB(password) {
    if (!process.env.VUE_APP_IS_WEB) {
      var user = null;
      await this.GET_USER_FROM_DB()
        .then(res => {
          if (res) {
            user = res;
          } else {
            return Promise.reject("There is no user in the database.");
          }
        })
        .catch(err => {
          return Promise.reject(err);
        });

      try {
        var hashedPassword = await argon2.hash(password);
      } catch (err) {
        Promise.reject(err);
      }

      user.password = hashedPassword;

      return new Promise((resolve, reject) => {
        new UserDB(user)
          .save()
          .then(res => {
            // console.log("res", res);
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  GET(id) {
    // TODO: needs work for desktop
    if (!process.env.VUE_APP_IS_WEB) {
      return new Promise((resolve, reject) => {
        new UserDB({ id: id, deleted: null })
          .fetch()
          .then(res => {
            UserORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      // console.log("is not desktop APP - call online API");
      return new Promise((resolve, reject) => {
        UserORM.api()
          .GET(id)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
  PUT(item) {
    if (!process.env.VUE_APP_IS_WEB) {
      var itemPut = JSON.parse(JSON.stringify(item));
      // console.log(itemPut);
      itemPut.updated = dates.get_now_utc(); // updated
      return new Promise((resolve, reject) => {
        new UserDB(itemPut)
          .save()
          .then(res => {
            // console.log(res);
            UserORM.insertOrUpdate({
              data: res.serialize(),
            });
            resolve(res.serialize());
          })
          .catch(err => {
            reject(err);
          });
      });
    } else {
      // console.log("is not desktop APP - call online API");
      return new Promise((resolve, reject) => {
        UserORM.api()
          .PUT(item)
          .then(res => {
            resolve(res.response.data);
          })
          .catch(err => {
            reject(err);
          });
      });
    }
  },
};
